(function () {
      const AB_STUDIO_API_DOMAIN = 'https://api-custom.medzt.com';

      // ── Config ────────────────────────────────────────────────────────────────
      var PUBLISH_RETRY_INTERVAL_MS  = 50;
      var PUBLISH_RETRY_MAX_ATTEMPTS = 60;            // tổng tối đa 400ms
      var FETCH_TIMEOUT_MS = 600;
      var CONTENT_CACHE_TTL_MS       = 5 * 60 * 1000; // 5 phút
      var PRICE_CACHE_TTL_MS            = 5  * 60 * 1000; // 5 phút — product page: refresh nhanh khi experiment ended
      var PRICE_OTHER_PAGE_CACHE_TTL_MS = 30 * 60 * 1000; // 30 phút — homepage/collection/search, delay tối đa 30 phút khi experiment ended vì visitor không mua từ các page này
                                                          // Cart Transform luôn verify server-side → checkout đúng giá
      var FIRST_PAGE_PRODUCT_TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90 ngày — first page là product page
      var FIRST_PAGE_OTHER_TTL_MS   = 24 * 60 * 60 * 1000;      // 24h — first page không phải product page

      // 8 placeholder chính thức Shopify money_format hỗ trợ (docs:
      // https://help.shopify.com/en/manual/international/pricing/currency-formatting)
      var KNOWN_MONEY_PLACEHOLDERS = [
        'amount',
        'amount_no_decimals',
        'amount_with_comma_separator',
        'amount_no_decimals_with_comma_separator',
        'amount_with_apostrophe_separator',
        'amount_no_decimals_with_space_separator',
        'amount_with_space_separator',
        'amount_with_period_and_space_separator',
      ];

      // Mỗi page category chỉ chạy 1 loại experiment tại 1 thời điểm.
      // Product page fetch parallel content + price nhưng content ưu tiên hơn price
      var PAGE_EXPERIMENT_TYPES = {
        'homepage':    ['content'],
        'product':     ['content', 'price'],
        'collection':  ['content'],
        'custom_page': ['content'],
      };

      // ── Page context — inject từ Shopify Liquid ───────────────────────────────
      var country          = window.ShopifyVars.context.country || null;
      var currency         = window.ShopifyVars.context.currency || null; // ISO code, vd: 'USD', 'EUR'
      var template_suffix  = window.ShopifyVars.context.template_suffix || null;
      var product_id       = window.ShopifyVars.context.product_id || null; // chỉ có trên product page
      var moneyFormat      = window.ShopifyVars?.context?.money_format || '';
      var currentView      = new URLSearchParams(window.location.search).get('view');
      var ref              = document.referrer && new URL(document.referrer).hostname;
      var referring_domain = (ref && ref !== window.location.hostname) ? ref : null;

      // ── Visitor/session identity ──────────────────────────────────────────────

      // visitor_id: lưu trong cookie TTL 1 năm
      function getVisitorId() {
        var name   = 'visitor_id=';
        var cookie = document.cookie.split('; ').find(function(c) { return c.startsWith(name); });
        if (cookie) return cookie.substring(name.length);
        var id = crypto.randomUUID();
        document.cookie = 'visitor_id=' + id + '; Max-Age=31536000; Path=/; SameSite=Lax';
        return id;
      }

      function getOrCreateId(storage, key) {
        try {
          var id = storage.getItem(key);
          if (!id) {
            id = crypto.randomUUID();
            storage.setItem(key, id);
          }
          return id;
        } catch (e) {
          console.warn('[ABStudio] Storage lỗi/bị chặn cho key ' + key + ':', e);
          return null;
        }
      }

      function getSplitUrlAssignment(variantPath) {
        try {
          var assignments = JSON.parse(sessionStorage.getItem(SPLIT_URL_ASSIGNMENT_KEY) || '{}');
          return assignments[variantPath] || null;
        } catch (e) {
          console.warn('[ABStudio] Failed to read split url assignment:', e);
          return null;
        }
      }

      function setSplitUrlAssignment(variantPath, assignment) {
        try {
          var assignments = JSON.parse(sessionStorage.getItem(SPLIT_URL_ASSIGNMENT_KEY) || '{}');
          assignments[variantPath] = assignment;
          sessionStorage.setItem(SPLIT_URL_ASSIGNMENT_KEY, JSON.stringify(assignments));
        } catch (e) {
          console.warn('[ABStudio] Failed to write split url assignment:', e);
        }
      }

      var visitor_id = getVisitorId();
      var session_id = getOrCreateId(sessionStorage, 'ab_session_id');

      // ── Helpers ───────────────────────────────────────────────────────────────
      function getDeviceType() {
        var ua = navigator.userAgent.toLowerCase();
        if (/tablet|ipad|playbook|silk/.test(ua)) return 'tablet';
        if (/mobile|iphone|ipod|android|blackberry|mini|windows\sce|palm/.test(ua)) return 'mobile';
        return 'desktop';
      }

      function getPageUrl() {
        var path = window.location.pathname.replace(/\/+$/, '');
        return path === '' ? '/' : path;
      }

      function getPageUrlFromUrl(url) {
        var path = url.pathname.replace(/\/+$/, '');
        return path === '' ? '/' : path;
      }

      function getContentExperimentCacheKey(targetPageUrl, targetCountry) {
        var resolvedPageUrl = targetPageUrl || pageUrl;
        var resolvedCountry = targetCountry || country || 'unknown';
        return resolvedCountry + '::' + resolvedPageUrl;
      }

      function getUTMParam(key) {
        var p     = new URLSearchParams(window.location.search);
        var value = p.get(key);
        if (value) {
          localStorage.setItem(key, value);
          return value;
        }
        return localStorage.getItem(key) || null;
      }

      function getPageCategory(pageUrl) {
        if (pageUrl === '/')                    return 'homepage';
        if (pageUrl.startsWith('/products'))    return 'product';
        if (pageUrl.startsWith('/collections')) return 'collection';
        if (pageUrl.startsWith('/pages'))       return 'custom_page';
        return null;
      }

      // Tính 1 lần, dùng lại cho cả fetchExperiment + getPageCategory
      var pageUrl    = getPageUrl();
      var deviceType = getDeviceType();
      var utmParams  = {
        utm_source:   getUTMParam('utm_source'),
        utm_medium:   getUTMParam('utm_medium'),
        utm_campaign: getUTMParam('utm_campaign'),
        utm_content:  getUTMParam('utm_content'),
        utm_term:     getUTMParam('utm_term'),
      };

      // ── Split URL assignment ──────────────────────────────────────────────────
      // A redirect sang B → A lưu assignment vào sessionStorage, key là path B. Ví dụ:
      //   sessionStorage['ab_split_url_assignment'] = {
      //     "/products/pillow-b": { control_path: "/products/pillow-a", experiment_id: 9, variant_id: 18 }
      //   }
      // B tìm entry theo path của mình → có: publish exp 9 / variant 18, canonical về A, không gọi API.
      //                                 → không có (vào B bằng link trực tiếp): không tính vào experiment.
      var SPLIT_URL_ASSIGNMENT_KEY = 'ab_split_url_assignment';
      var splitUrlAssignment       = getSplitUrlAssignment(pageUrl);
      var splitControlPath         = splitUrlAssignment ? splitUrlAssignment.control_path  : null;
      var splitExperimentId        = splitUrlAssignment ? splitUrlAssignment.experiment_id : null;
      var splitVariantId           = splitUrlAssignment ? splitUrlAssignment.variant_id    : null;
      var isSplitUrlVariant        = !!splitUrlAssignment;

      // ── First page tracking ───────────────────────────────────────────────────
      // Lưu trang đầu tiên visitor vào store. Price experiment chỉ apply khi
      // first page = product page đang được test.
      // Hết hạn → reset → visitor có cơ hội test lại.
      var firstPage = (function() {
        var data = JSON.parse(localStorage.getItem('ab_first_page') || 'null');
        var ttl  = data && data.url.startsWith('/products')
          ? FIRST_PAGE_PRODUCT_TTL_MS
          : FIRST_PAGE_OTHER_TTL_MS;

        if (!data || Date.now() - data.t > ttl) {
          data = { url: pageUrl, t: Date.now() };
          localStorage.setItem('ab_first_page', JSON.stringify(data));
        }

        return data.url;
      })();

      // ── Canonical tag (Split URL) — chạy độc lập, không phụ thuộc fetch ────────
      (function injectCanonicalTagIfNeeded() {
        if (!splitControlPath) return;
        var existing = document.querySelector('link[rel="canonical"]');
        if (existing) existing.remove();
        var link  = document.createElement('link');
        link.rel  = 'canonical';
        link.href = window.location.origin + splitControlPath;
        document.head.appendChild(link);
      })();

      // ── Build experiment data ─────────────────────────────────────────────────
      // experiment = null khi không có test nào chạy — experiment_id/variant_id
      // trả về null, các field visitor/session/UTM vẫn đầy đủ như bình thường.
      function buildExperimentData(experiment, extraData) {
        return Object.assign({
          experiment_id:    experiment ? experiment.experiment_id : null,
          variant_id:       experiment ? experiment.variant_id    : null,
          visitor_id:       visitor_id,
          session_id:       session_id,
          country:          country,
          referring_domain: referring_domain,
          fbclid:           getUTMParam('fbclid'),
          gclid:            getUTMParam('gclid'),
          ttclid:           getUTMParam('ttclid'),
          cjevent:          getUTMParam('cjevent'),
          epik:             getUTMParam('epik'),
          utm_source:       utmParams.utm_source,
          utm_medium:       utmParams.utm_medium,
          utm_campaign:     utmParams.utm_campaign,
          utm_content:      utmParams.utm_content,
          utm_term:         utmParams.utm_term,
        }, extraData || {});
      }

      // ══════════════════════════════════════════════════════════════════════════
      // Resolve action theo loại experiment trong 'content' — ĐÂY LÀ NƠI DUY NHẤT
      // cần sửa/thêm khi Duplicate Template hay Split URL đổi cách trả dữ liệu.
      // ══════════════════════════════════════════════════════════════════════════

      function resolveTemplateAction(suffix, baseUrl, refCurrentView) {
        if (suffix === '' || refCurrentView === suffix) return { type: 'stay' };
        if (!suffix) return null;
        var url = new URL(baseUrl);
        url.searchParams.set('view', suffix);
        return { type: 'redirect', url: url.toString() };
      }

      function resolveSplitUrlAction(variantPath, passUrlParams, refPageUrl, sourceQueryString) {
        if (!variantPath || variantPath === refPageUrl) return { type: 'stay' };
        var target = new URL(window.location.origin + variantPath);
        if (passUrlParams) {
          new URLSearchParams(sourceQueryString).forEach(function(value, key) {
            target.searchParams.set(key, value);
          });
        }
        return { type: 'redirect', url: target.toString() };
      }

      function resolveActionForVariant(variantData, opts) {
        if (!variantData) return null;
        if (typeof variantData.path === 'string') {
          return resolveSplitUrlAction(variantData.path, variantData.pass_url_params, opts.refPageUrl, opts.sourceQueryString);
        }
        if (typeof variantData.template_suffix === 'string') {
          return resolveTemplateAction(variantData.template_suffix, opts.baseUrlForRedirect, opts.refCurrentView);
        }
        return null;
      }

      function applyContentExperiment(action, data) {
        if (action.type === 'redirect') {
          saveSplitUrlAssignment(action.url, data);
          window.location.replace(action.url);
          return;
        }
        publishExperiment(data);
      }

      // Split URL redirect sang path khác → ghi entry cho path đích để B nhận diện
      // là variant. ?view= (Duplicate Template) redirect cùng path → bỏ qua.
      function saveSplitUrlAssignment(redirectUrl, data) {
        var targetPageUrl = getPageUrlFromUrl(new URL(redirectUrl, window.location.origin));
        if (targetPageUrl === pageUrl) return;
        setSplitUrlAssignment(targetPageUrl, {
          control_path:  pageUrl,
          experiment_id: data.experiment_id,
          variant_id:    data.variant_id,
        });
      }

      // ── Content experiment cache (localStorage + TTL 5 phút) ─────────────────
      // localStorage để persist qua các tab, tránh call API lại khi mở tab mới
      function getCachedContentExperiment(targetPageUrl) {
        try {
          var cacheKey = getContentExperimentCacheKey(targetPageUrl);
          var cache    = JSON.parse(localStorage.getItem('ab_content_experiment_cache') || '{}');
          var cached   = cache[cacheKey] || null;
          if (!cached) return null;

          // Cache hết TTL → xóa + return null → sẽ call API lại
          if (Date.now() - cached.cached_at > CONTENT_CACHE_TTL_MS) {
            delete cache[cacheKey];
            localStorage.setItem('ab_content_experiment_cache', JSON.stringify(cache));
            return null;
          }

          return cached;
        } catch(e) {
          console.warn('[ABStudio] Failed to read content experiment cache:', e);
          return null;
        }
      }

      function setCachedContentExperiment(data, targetPageUrl) {
        try {
          var cacheKey = getContentExperimentCacheKey(targetPageUrl, data && data.country);
          var cache    = JSON.parse(localStorage.getItem('ab_content_experiment_cache') || '{}');
          cache[cacheKey] = Object.assign({}, data, { cached_at: Date.now() });
          localStorage.setItem('ab_content_experiment_cache', JSON.stringify(cache));
        } catch(e) {
          console.warn('[ABStudio] Failed to write content experiment cache:', e);
        }
      }

      // Cache per product_id → lưu tất cả variant configs của product
      function getPriceExperimentCacheByProd(productId) {
        try {
          if (!productId) return null;
          var cache  = JSON.parse(localStorage.getItem('ab_price_experiment_cache') || '{}');
          var cached = cache[productId] || null;
          if (!cached) return null;

          // Cache hết TTL → xóa + return null → sẽ call API lại
          if (Date.now() - cached.cached_at > PRICE_CACHE_TTL_MS) {
            console.log('[ABStudio] Price cache expired, remove:', productId);
            delete cache[productId];
            localStorage.setItem('ab_price_experiment_cache', JSON.stringify(cache));
            return null;
          }

          // Country hiện tại không khớp country lúc cache → coi như cache miss
          if (cached.country !== country) {
            console.log('[ABStudio] Price cache country mismatch, ignore:', cached.country, country);
            delete cache[productId];
            localStorage.setItem('ab_price_experiment_cache', JSON.stringify(cache));
            return null;
          }

          return cached;
        } catch(e) {
          console.warn('[ABStudio] Failed to read price experiment cache:', e);
          return null;
        }
      }

      function setPriceExperimentCache(productId, data) {
        try {
          if (!productId) return;
          var cache        = JSON.parse(localStorage.getItem('ab_price_experiment_cache') || '{}');
          cache[productId] = Object.assign({}, data, { country: country, cached_at: Date.now() });
          localStorage.setItem('ab_price_experiment_cache', JSON.stringify(cache));
        } catch(e) {
          console.warn('[ABStudio] Failed to write price experiment cache:', e);
        }
      }

      // Build cache object từ data + action đã resolve — dùng chung mọi nơi
      function buildCacheContentData(data, action, targetPageUrl) {
        return Object.assign({}, data,
          action.type === 'redirect' ? { action: 'redirect', url: action.url } : { action: 'stay' },
          { page_url: targetPageUrl }
        );
      }

      // Nếu cached redirect trỏ tới cùng path (chỉ khác ?view=) → trả về suffix đó.
      // Nếu trỏ sang path khác hẳn (vd Split URL) → trả null, không áp dụng được
      // cho việc rewrite href của link (chỉ hữu ích cho hover-prefetch).
      function getSamePathViewParam(redirectUrl, targetPageUrl) {
        try {
          var u     = new URL(redirectUrl, window.location.origin);
          var uPath = u.pathname.replace(/\/+$/, '') || '/';
          if (uPath !== targetPageUrl) return null;
          return u.searchParams.get('view');
        } catch(e) {
          return null;
        }
      }

      // ── Fetch experiment theo type ────────────────────────────────────────────
      function fetchExperiment(type, targetPageUrl) {
        var input = {
          page_url:         targetPageUrl || pageUrl,
          visitor_id:       visitor_id,
          device_type:      deviceType,
          experiment_type:  type,
          template_suffix:  template_suffix,
          utm_source:       utmParams.utm_source,
          utm_medium:       utmParams.utm_medium,
          utm_campaign:     utmParams.utm_campaign,
          utm_content:      utmParams.utm_content,
          country:          country,
          referring_domain: referring_domain,
        };

        // Price experiment cần thêm product_id để query đúng experiment
        if (type === 'price' && product_id) {
          input.experiment_data = { product_id: product_id };
        }

        return fetch(AB_STUDIO_API_DOMAIN + '/active-experiment', {
          method: 'POST',
          signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: [
              'query GetActiveExperiment($input: GetActiveExperimentInput!) {',
              '  getActiveExperiment(input: $input) {',
              '    experiment_id',
              '    variant_id',
              '    experiment_type',
              '    variant_data',
              '  }',
              '}'
            ].join('\n'),
            variables: { input: input }
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('API error: ' + res.status);
          return res.json();
        })
        .catch(function(err) {
          console.warn('[ABStudio] fetchExperiment(' + type + ') failed:', err);
          if (err.name === 'AbortError') {
            console.log('[ABStudio] API aborted by prehide timeout');
          }
          return null;
        });
      }

      // ── Publish sự kiện cho Pixel ─────────────────────────────────────────────
      var hasPublishedTrackingEvent = false;

      function publish(eventName, data) {
        function tryPublish() {
          if (!(window.Shopify && window.Shopify.analytics)) return false;
          try {
            Shopify.analytics.publish(eventName, data);
            return true;
          } catch (err) {
            console.warn('[ABStudio] Failed to publish ' + eventName + ' event:', err);
            return false;
          }
        }

        if (tryPublish()) return Promise.resolve(true);

        return new Promise(function(resolve) {
          var attempts      = 0;
          var retryInterval = setInterval(function () {
            attempts++;
            if (tryPublish()) {
              clearInterval(retryInterval);
              resolve(true);
            } else if (attempts >= PUBLISH_RETRY_MAX_ATTEMPTS) {
              console.warn('[ABStudio] Shopify.analytics not available after retries, giving up.');
              clearInterval(retryInterval);
              resolve(false);
            }
          }, PUBLISH_RETRY_INTERVAL_MS);
        });
      }

      function publishExperiment(data) {
        hasPublishedTrackingEvent = true;
        return publish('abstudio:experiment_assigned', data);
      }

      function publishNoActiveExperiment() {
        if (hasPublishedTrackingEvent) return;
        try {
          publishExperiment(buildExperimentData(null));
        } catch (e) {
          console.warn('[ABStudio] publishNoActiveExperiment failed:', e);
        }
      }

      // ══════════════════════════════════════════════════════════════════════════
      // PRICE EXPERIMENT
      // ══════════════════════════════════════════════════════════════════════════

      // ── Tính giá test từ config + giá gốc ────────────────────────────────────
      function calcNewPrice(originalPrice, config) {
        // Convert sang integer cents để tránh floating point errors
        // Đồng bộ logic tính giá với Cart Transform → kết quả luôn khớp
        var originalCents = Math.round(originalPrice * 100);
        var newCents = null;
        if (config.price_type === 'percentage')   newCents = Math.round(originalCents * (1 - config.price_value / 100));
        if (config.price_type === 'fixed_amount') newCents = Math.round(originalCents - config.price_value * 100);
        if (config.price_type === 'fixed_price')  newCents = Math.round(config.price_value * 100);
        // Convert cents → dollars: 65696 cents → $656.96
        return newCents !== null ? newCents / 100 : null;
      }

      // Xác định decimal separator dựa theo placeholder đang dùng trong
      // moneyFormat, để biết chính xác dấu nào là thập phân/hàng nghìn khi
      // parse ngược lại từ text (tránh nhầm '.'/',' )
      function getDecimalSeparator() {
        var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        var name = match[1];
        if (name.indexOf('with_comma_separator') !== -1) return ',';
        if (name.indexOf('with_space_separator') !== -1 && name.indexOf('period_and_space') === -1) return ',';
        return '.';
      }

      // Parse giá từ DOM text theo ĐÚNG decimal separator của store
      function parsePriceFromText(text) {
        var decimalSep = getDecimalSeparator();
        var cleaned = (text || '').replace(/[^0-9.,\s']/g, '');
        if (decimalSep === ',') {
          cleaned = cleaned.replace(/[.\s']/g, '').replace(',', '.');
        } else {
          cleaned = cleaned.replace(/[,\s']/g, '');
        }
        var num = parseFloat(cleaned);
        return isNaN(num) ? null : num;
      }

      // Check money_format hợp lệ: PHẢI có placeholder dạng {{...}} VÀ tên placeholder hợp lệ
      function isMoneyFormatValid(format) {
        if (!format || typeof format !== 'string') return false;
        var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!match) return false;
        return KNOWN_MONEY_PLACEHOLDERS.indexOf(match[1]) !== -1;
      }

      // Chèn dấu phân cách hàng nghìn/thập phân tùy chỉnh vào số.
      // Vd: (1234.5, 2, '.', ',') -> '1.234,50' | (1234.5, 2, ',', '.') -> '1,234.50'
      function formatWithDelimiters(number, precision, thousands, decimal) {
        var parts = number.toFixed(precision).split('.'); // ['1234','50']
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands); // chèn thousands mỗi nhóm 3 số
        return parts[1] ? whole + decimal + parts[1] : whole; // ghép phần thập phân (nếu có)
      }

      // Format giá theo money_format của store. Không cần xử lý case moneyFormat
      // invalid/placeholder lạ ở đây — đã được chặn từ trước qua
      // isMoneyFormatValid() ở mọi điểm gọi vào luồng price, nên khi formatPrice được gọi, moneyFormat CHẮC CHẮN hợp lệ.
      function formatPrice(amount) {
        var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);

        var value;
        switch (match[1]) {
          case 'amount':                                    value = formatWithDelimiters(amount, 2, ',', '.'); break;
          case 'amount_no_decimals':                         value = formatWithDelimiters(amount, 0, ',', '.'); break;
          case 'amount_with_comma_separator':                value = formatWithDelimiters(amount, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator':     value = formatWithDelimiters(amount, 0, '.', ','); break;
          case 'amount_with_apostrophe_separator':            value = formatWithDelimiters(amount, 2, "'", '.'); break;
          case 'amount_no_decimals_with_space_separator':     value = formatWithDelimiters(amount, 0, ' ', '.'); break;
          case 'amount_with_space_separator':                 value = formatWithDelimiters(amount, 2, ' ', ','); break;
          case 'amount_with_period_and_space_separator':      value = formatWithDelimiters(amount, 2, ' ', '.'); break;
        }
        return moneyFormat.replace(match[0], value);
      }

      // Tính % giảm giá từ compare price → new price
      function calcDiscountPercent(comparePrice, price) {
        if (!comparePrice || !price || comparePrice <= price) return null;
        return Math.round((comparePrice - price) / comparePrice * 100);
      }

      // ── Override DOM giá cho 1 variant cụ thể ────────────────────────────────
      // Tìm config theo variantId → override price + compare_at_price trên DOM
      // Variant A (control) hoặc không có config → không override → giá gốc Shopify
      function applyPriceConfigToDOM(productId, variantId, priceVariants) {
        if (!productId || !variantId || !priceVariants) {
          console.log('[ABStudio] Price DOM skip: missing params', { productId, variantId, priceVariants: !!priceVariants });
          return;
        }

        // Tìm config cho variant này trong price_variants
        var config = null;
        for (var i = 0; i < priceVariants.length; i++) {
          var pv = priceVariants[i];
          if (String(pv.product_variant_id) === String(variantId)) {
            config = pv;
            break;
          }
        }

        // Không có config → variant A (control) → không override → giá gốc Shopify ✅
        if (!config) {
          console.log('[ABStudio] Price DOM skip: no config for variant', { productId, variantId, priceVariants });
          return;
        }

        // Tìm tất cả elements giá của variant này
        // Có thể có 2 elements: price__regular + price__sale (CSS tự toggle)
        var salePriceEls = document.querySelectorAll(
          '[data-price-sale="' + productId + '"][data-product-variant-id="' + variantId + '"]'
        );
        if (!salePriceEls.length) {
          console.log('[ABStudio] Price DOM skip: no elements found', { productId, variantId });
          return;
        }

        // Đọc giá gốc từ element đang visible (offsetParent !== null)
        // price__regular visible khi không có sale, price__sale visible khi có sale
        var originalPrice = null;
        salePriceEls.forEach(function(el) {
          if (originalPrice === null && el.offsetParent !== null) {
            originalPrice = parsePriceFromText(el.textContent);
          }
        });
        if (originalPrice === null) {
          console.log('[ABStudio] Price DOM skip: cannot parse originalPrice');
          return;
        }

        // Tính giá test
        var newPrice = calcNewPrice(originalPrice, config);
        if (newPrice === null || newPrice === originalPrice) {
          console.log('[ABStudio] Price DOM skip: newPrice invalid', { newPrice, originalPrice });
          return;
        }

        // Override tất cả price sale elements
        // CSS tự toggle đúng element visible (price__regular hoặc price__sale)
        salePriceEls.forEach(function(el) {
          el.textContent = formatPrice(newPrice);
        });

        // Override compare_at_price nếu Shopify có sẵn
        // Giữ nguyên chênh lệch: new_compare = new_price + (original_compare - original_price)
        // Shopify không có compare_at_price → compareEl không visible → skip ✅
        var compareEl = document.querySelector(
          '[data-price-compare="' + productId + '"][data-product-variant-id="' + variantId + '"]'
        );
        if (compareEl && compareEl.offsetParent !== null) {
          var comparePrice = parsePriceFromText(compareEl.textContent);
          if (comparePrice && comparePrice > originalPrice) {
            var diff = comparePrice - originalPrice;
            var newComparePrice = newPrice + diff;
            compareEl.textContent = formatPrice(newComparePrice);

            // Tính % giảm từ newComparePrice → newPrice
            var discountPercent = calcDiscountPercent(newComparePrice, newPrice);
            var bannerEl = document.querySelector('.sale-banner__title');
            if (bannerEl && discountPercent) {
              bannerEl.textContent = discountPercent + '% OFF';
            }
          }
        }
        console.log('[ABStudio] applyPriceConfigToDOM ' + originalPrice + ' -> ' + newPrice + ' product-variant_id=' + variantId)
        return newPrice;
      }

      // ── Apply price cache cho homepage/collection/search ──────────────────────
      // Chỉ apply đúng product của first page, các product khác giữ giá gốc
      // Không call API, không init observer, không fill hidden inputs
      function applyPriceCacheToPage() {
        if (hasActiveDiscount()) {
          console.log('[ABStudio] applyPriceCacheToPage skip: discount active');
          return;
        }

        if (!isMoneyFormatValid(moneyFormat)) {
          console.log('[ABStudio] applyPriceCacheToPage skip: moneyFormat invalid', moneyFormat);
          return;
        }

        if (pageUrl.startsWith('/products')) {
          console.log('[ABStudio] applyPriceCacheToPage skip: product page');
          return;
        }
        // Chỉ apply nếu first page là product page
        if (!firstPage || !firstPage.startsWith('/products')) {
          console.log('[ABStudio] applyPriceCacheToPage skip: firstPage not product', firstPage);
          return;
        }

        // Lấy price cache — chỉ có tối đa 1 product được test (first page product)
        var cache = JSON.parse(localStorage.getItem('ab_price_experiment_cache') || '{}');
        var keys  = Object.keys(cache);
        if (!keys.length) return;

        var productId  = keys[0];
        var cachedData = cache[productId];
        if (!cachedData) return;

        // Check TTL
        if (Date.now() - cachedData.cached_at > PRICE_OTHER_PAGE_CACHE_TTL_MS) {
          console.log('[ABStudio] applyPriceCacheToPage cache expired');
          return;
        }

        if (cachedData.country !== country) {
          console.log('[ABStudio] applyPriceCacheToPage country mismatch, ignore:', cachedData.country, country);
          return;
        }

        var priceVariants = cachedData.variant_data && cachedData.variant_data.price_variants;
        if (!priceVariants) {
          console.log('[ABStudio] applyPriceCacheToPage skip: no priceVariants');
          return;
        }
        applyOtherPagePriceWhenReady(productId, priceVariants);
      }

      function applyProductPagePriceWhenReady(experiment, priceVariants) {
        function apply() {
          var variantInput = document.querySelector('input.product-variant-id');
          if (!variantInput) {
            console.log('[ABStudio] Price skip: no variantInput after DOM ready');
            return;
          }
          var variantId = variantInput.value;
          if (!variantId) {
            console.log('[ABStudio] Price skip: no variantId after DOM ready');
            return;
          }
          var newPrice = applyPriceConfigToDOM(product_id, variantId, priceVariants);
          if (newPrice) {
            console.log('[ABStudio] applyProductPage applied:', product_id, variantId, '->', newPrice, 'country =', country, 'currency =', currency);
          } else {
            console.log('[ABStudio] applyProductPage: no price change for', product_id, variantId, 'country =', country, 'currency =', currency);
          }

          // Set value NGAY, không đợi submit — để app custom (nếu tự đọc DOM input, không qua form submit chuẩn) vẫn lấy được
          // Không phụ thuộc sự kiện 'submit' có fire hay không.
          var vidEl = document.querySelector('input[name="properties[_ab_variant_id]"]');
          if (vidEl) vidEl.value = experiment.variant_id;

          publishExperiment(buildExperimentData(experiment, { new_price: newPrice || null }));
          onProductVariantChange();
          fillCartHiddenInputsOnSubmit();
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', apply);
        } else {
          apply();
        }
      }

      function applyOtherPagePriceWhenReady(productId, priceVariants) {
        function apply() {
          var els = document.querySelectorAll('[data-price-sale="' + productId + '"]');

          // Lấy unique variantIds → apply 1 lần per variant
          var variantIds = {};
          els.forEach(function(el) {
            var variantId = el.getAttribute('data-product-variant-id');
            if (variantId) variantIds[variantId] = true;
          });

          Object.keys(variantIds).forEach(function(variantId) {
            applyPriceConfigToDOM(productId, variantId, priceVariants);
          });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', apply);
        } else {
          apply();
        }
      }

      // ── Price experiment handler (product page) ───────────────────────────────
      // Apply giá test cho product page:
      // fromCache=true: đọc từ localStorage cache, không lưu lại (tránh lưu 2 lần)
      // fromCache=false: từ API response, lưu cache
      function handlePriceExperiment(experiment, fromCache) {
        if (hasActiveDiscount()) {
          console.log('[ABStudio] Price skip: discount active');
          return;
        }

        if (!isMoneyFormatValid(moneyFormat)) {
          console.log('[ABStudio] Price skip: moneyFormat invalid', moneyFormat);
          return;
        }

        if (!experiment || !product_id) {
          console.log('[ABStudio] Price skip: no experiment or product_id', { experiment, product_id });
          return;
        }

        // Chỉ apply cho first page = product page đang được test
        // Visitor vào homepage trước → first page = '/' → skip
        // Visitor vào product khác trước → first page ≠ pageUrl → skip
        if (firstPage !== pageUrl) {
          console.log('[ABStudio] Price experiment skipped: not first page');
          return;
        }

        var priceVariants = experiment.variant_data && experiment.variant_data.price_variants;
        if (!priceVariants) {
          console.log('[ABStudio] Price skip: no priceVariants', experiment.variant_data);
          return;
        }

        // Lưu cache nếu từ API (fromCache=false)
        // fromCache=true → đã có cache rồi, không lưu lại tránh reset cached_at
        if (!fromCache) {
          setPriceExperimentCache(product_id, experiment);
        }

        applyProductPagePriceWhenReady(experiment, priceVariants);
      }

      // Đổi variant (size, màu sắc...) trên product page.
      // Dùng MutationObserver theo dõi attribute 'value' thay đổi.
      // Dawn fetch section HTML mới từ server → replace DOM → cần retry đợi DOM settle.
      function onProductVariantChange() {
        if (!product_id) {
          console.log('[ABStudio] onProductVariantChange skip: no product_id');
          return;
        }

        var variantInput = document.querySelector('input.product-variant-id');
        if (!variantInput) {
          console.log('[ABStudio] onProductVariantChange skip: input not found');
          return;
        }

        var RETRY_INTERVAL = 150;
        var MAX_RETRIES    = 5;
        var lastVariantId  = variantInput.value;

        new MutationObserver(function() {
          if (variantInput.value === lastVariantId) return;
          lastVariantId = variantInput.value;
          console.log('[ABStudio] variant changed:', lastVariantId);

          // Dawn fetch HTML mới từ server rồi replace DOM giá
          // → Đợi 200ms cho DOM bắt đầu render, sau đó retry nếu chưa có elements
          var retries = 0;
          function tryApply() {
            var cache = getPriceExperimentCacheByProd(product_id);
            if (!cache || !cache.variant_data || !cache.variant_data.price_variants) {
              console.log('[ABStudio] variant change skip: no cache');
              return;
            }

            var newPrice = applyPriceConfigToDOM(product_id, lastVariantId, cache.variant_data.price_variants);
            if (newPrice) {
              console.log('[ABStudio] variant change applied:', newPrice, 'retry:', retries);
              return;
            }

            if (++retries < MAX_RETRIES) {
              setTimeout(tryApply, RETRY_INTERVAL);
            } else {
              console.log('[ABStudio] variant change: gave up after', MAX_RETRIES, 'retries');
            }
          }

          setTimeout(tryApply, 300);
        }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }

      // ── Fill hidden inputs khi visitor submit Add to Cart ─────────────────────
      function fillCartHiddenInputsOnSubmit() {
        document.addEventListener('submit', function(e) {
          var form = e.target;
          if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
          if (!product_id) return;

          var vidEl = form.querySelector('input[name="properties[_ab_variant_id]"]');
          if (!vidEl) return;

          var cache = getPriceExperimentCacheByProd(product_id);
          if (cache && cache.variant_id) vidEl.value = cache.variant_id;
        }, true);
      }

      // ══════════════════════════════════════════════════════════════════════════
      // CONTENT EXPERIMENT
      // ══════════════════════════════════════════════════════════════════════════

      function handleContentExperiment(experiment, isVersionBResolved) {
        if (isVersionBResolved) {
          // Case ?view= (Duplicate Template): landing page CÙNG path với trang
          // gốc → đọc được cache (cùng cache key), publish lại đầy đủ
          // experiment_id/variant_id thật.
          //
          // Case Split URL (landing ở B, path khác A): B KHÔNG đọc được cache
          // của A (khác cache key) — dùng entry sessionStorage A ghi lúc redirect
          // để publish đủ experiment_id/variant_id thật.
          var cached = getCachedContentExperiment();
          if (cached) {
            publishExperiment(cached);
          } else {
            publishExperiment(buildExperimentData(
              splitExperimentId ? { experiment_id: splitExperimentId, variant_id: splitVariantId } : null
            ));
          }
          return;
        }

        if (!experiment) {
          return;
        }

        var action = resolveActionForVariant(experiment.variant_data, {
          refPageUrl:         pageUrl,
          refCurrentView:     currentView,
          baseUrlForRedirect: window.location.href,
          sourceQueryString:  window.location.search
        });

        if (!action) {
          console.warn('[ABStudio] Cannot resolve action for variant_data:', experiment);
          return;
        }

        var data = buildExperimentData(experiment);
        setCachedContentExperiment(buildCacheContentData(data, action, pageUrl));
        applyContentExperiment(action, data);
      }

      var EXPERIMENT_IS_VERSION_B = {
        'content': function() {
          // currentView !== null: đã redirect ?view= rồi (Duplicate Template)
          // isSplitUrlVariant: đang là variant (B) landing từ Split URL
          return currentView !== null || isSplitUrlVariant;
        },
      };

      // ── Link prefetch: apply cached view khi hover/click link ────────────────
      function getEligibleContentLink(link) {
        if (!link || !link.href || link.target || link.hasAttribute('download')) return null;

        var url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.searchParams.has('view')) return null;

        var targetPageUrl = getPageUrlFromUrl(url);
        if (targetPageUrl === pageUrl) return null;
        if ((PAGE_EXPERIMENT_TYPES[getPageCategory(targetPageUrl)] || []).indexOf('content') === -1) return null;

        return { url: url, page_url: targetPageUrl };
      }

      function applyCachedViewToLink(link) {
        var target = getEligibleContentLink(link);
        if (!target) return false;

        var cachedData = getCachedContentExperiment(target.page_url);
        if (!cachedData) return false;
        if (cachedData.action !== 'redirect') return true;

        var viewSuffix = getSamePathViewParam(cachedData.url, target.page_url);
        if (!viewSuffix) return true;

        target.url.searchParams.set('view', viewSuffix);
        link.href = target.url.toString();
        return true;
      }

      function getLinkFromEvent(event) {
        return event.target && event.target.closest && event.target.closest('a[href]');
      }

      document.addEventListener('click', function(event) {
        applyCachedViewToLink(getLinkFromEvent(event));
      }, true);

      function handlePriceResult(priceResult) {
        if (!priceResult) {
          publishNoActiveExperiment();
          return;
        }
        var experiment = priceResult.data && priceResult.data.getActiveExperiment;
        if (!experiment) {
          publishNoActiveExperiment();
          return;
        }
        handlePriceExperiment(experiment, false);
      }

      // Return true nếu content có data → không xử lý price
      // Return false nếu content null → tiếp tục xử lý price
      function handleContentResult(contentResult) {
        var isVersionBResolved = contentResult && contentResult.isVersionBResolved === true;
        var experiment = isVersionBResolved
          ? null
          : (contentResult && contentResult.data && contentResult.data.getActiveExperiment);

        // Đang ở trang B (sau redirect) → publish + reveal → không xử lý price
        if (isVersionBResolved) {
          handleContentExperiment(null, true);
          return true;
        }

        // Content null → reveal → tiếp tục xử lý price
        if (!experiment) {
          return false;
        }

        // Content có data → xử lý content → không xử lý price
        handleContentExperiment(experiment, false);
        return true;
      }

      function hasActiveDiscount() {
        // URL đang có utm_discount
        var urlHasDiscount = new URLSearchParams(window.location.search).has('utm_discount');
        if (urlHasDiscount) return true;

        // Cookie utm_discount còn từ lần trước
        var cookieString = document.cookie; // vd: "utm_discount=BF30FB; other=abc"
        var cookieHasDiscount = cookieString.indexOf('utm_discount=') !== -1;
        return cookieHasDiscount;
      }

      // ══════════════════════════════════════════════════════════════════════════
      // MAIN FLOW
      // ══════════════════════════════════════════════════════════════════════════
      // homepage/collection/search: scan DOM apply giá từ cache của first page product
      applyPriceCacheToPage();

      // ── Early exit nếu không có experiment
      var pageCategory    = getPageCategory(pageUrl);
      var experimentTypes = PAGE_EXPERIMENT_TYPES[pageCategory] || [];
      if (experimentTypes.length === 0) {
        console.log('[ABStudio] No experiment types for pagea category: ' + pageCategory);
        publishNoActiveExperiment();
        return;
      }

      // ── Bước 1: Check content cache trước ────────────────────────────────────
      if (currentView === null && !isSplitUrlVariant &&experimentTypes.indexOf('content') !== -1) {
        var cachedContentExperiment = getCachedContentExperiment();
        if (cachedContentExperiment) {
          var action = cachedContentExperiment.action === 'redirect'
            ? { type: 'redirect', url: cachedContentExperiment.url }
            : { type: 'stay' };
          applyContentExperiment(action, cachedContentExperiment);
          return;
        }
      }

      // ── Bước 2: Apply price cache (KHÔNG call API) ────────────────────────────
      // product page: apply cache cho đúng product này nếu first page khớp
      // homepage/collection/search: apply cache cho product của first page
      if (pageCategory === 'product' && product_id) {
        var cachedPriceExperiment = getPriceExperimentCacheByProd(product_id);
        if (cachedPriceExperiment) {
          handlePriceExperiment(cachedPriceExperiment, true);
          return;
        }
      }

      // ── Bước 3: Parallel fetch ────────────────────────────────────────────────
      // Content + price fetch cùng lúc → tổng thời gian = max(content, price)
      // Content ưu tiên hơn price: content có data → bỏ price dù price có data

      Promise.all(experimentTypes.map(function(type) {
        if (type === 'price') {
          // Price chỉ fetch khi: product page + first page khớp + cache miss
          // + không có utm_discount + moneyFormat hợp lệ
          if (!product_id || firstPage !== pageUrl) return Promise.resolve(null);
          if (hasActiveDiscount()) {
            console.log('[ABStudio] Price fetch skip: discount active');
            return Promise.resolve(null);
          }
          if (!isMoneyFormatValid(moneyFormat)) {
            console.log('[ABStudio] Price fetch skip: moneyFormat invalid', moneyFormat);
            return Promise.resolve(null);
          }

          return fetchExperiment('price');
        }

        // Content: check isVersionB trước
        var checkVersionB = EXPERIMENT_IS_VERSION_B[type];
        if (checkVersionB && checkVersionB()) return Promise.resolve({ isVersionBResolved: true });
        return fetchExperiment(type);
      }))
      .then(function(results) {
        var contentResult = null;
        var priceResult   = null;
        // Tách content + price result
        experimentTypes.forEach(function(type, i) {
          if (type === 'content') contentResult = results[i];
          if (type === 'price')   priceResult   = results[i];
        });

        // Xử lý content trước → price sau
        var contentHandled = handleContentResult(contentResult);
        if (!contentHandled) {
          handlePriceResult(priceResult);
        }
      })
      .catch(function(err) {
        console.warn('[ABStudio] Main flow failed:', err);
        publishNoActiveExperiment();
      });
})();